<template>
    <load v-if="loading" message="Carregando as últimas  atualizações" />
    <div v-else>
        <div class="col-12 px-0">
            <div class="d-flex align-items-center justify-content-between mb-4">
                <h1 class="h3 mb-0 text-gray-800">Central de atualizações</h1>
                <button
                    class="btn bg-light mb-0 text-gray-800"
                    @click="$emit('voltar')"
                >
                    <i class="mdi mdi-chevron-left"></i>
                    Voltar
                </button>
            </div>
        </div>

        <div class="row px-0">
            <div class="col-3" v-for="(post, index) in posts" :key="index">
                <b-card class="shadow">
                    <b-card-text>
                        <h3>
                            <!-- {{ post.title }} -->
                            📢✨ ATUALIZAÇÃO do Sistema
                        </h3>
                        {{ post.cadastrado }}
                        <button
                            class="btn btn-primary col-12 d-flex justify-content-center mt-3"
                            @click="
                                comunicadoSelected = post;
                                $bvModal.show('update-modal');
                            "
                        >
                            <span class="d-flex align-items-center">
                                <i
                                    class="mdi mdi-open-in-new mdi-18px mr-2"
                                ></i>
                                Abrir
                            </span>
                        </button>
                    </b-card-text>
                </b-card>
            </div>
        </div>
        <Footer />
        <ModalAtualizacao :comunicado="comunicadoSelected" />
    </div>
</template>

<script>
import Footer from "./Footer";
import ModalAtualizacao from "./ModalAtualizacao";
export default {
    components: { Footer, ModalAtualizacao },
    name: "CentralAtualizacao",
    metaInfo() {
        return {
            title: this.$i18n.t("Central de Atualizações"),
        };
    },
    data() {
        return {
            loading: true,
            posts: [],
            comunicadoSelected: "",
        };
    },
    mounted() {
        this.getPosts();
    },
    methods: {
        getPosts() {
            axios
                .get("api/dashboard/posts")
                .then((response) => {
                    this.posts = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style>
.shadow {
    box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 5%) !important;
}
</style>
